// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"77f9c85e","454":"be463651","592":"0c9395f9"}[chunkId] + ".chunk.js";
};